import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import {
  hidePlatsaAddingFrontToOpenFrameErrorMessage,
  hidePlatsaSlidingDoorsNotPossibleErrorMessage
} from '../rules/hideMenuRules';

const autoFillSlidingDoors = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const framesInScene = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
  const framesThatCanHaveSlidingDoors = framesInScene.filter(frame => {
    const frameSize = coreApi.entities.getEntityComSize(frame);
    const slidingDoorsInFrameSize = rootState.products.inMarket.find(
      p =>
        p.type === ProductType.PLATSA_SLIDING_DOOR_ASM &&
        p.communicatedDimensions.width === frameSize?.width &&
        p.communicatedDimensions.height === frameSize?.height
    );
    const alignedFrames = coreApi.entities.getAlignedFrames(
      frame,
      'align-frame-left',
      'align-frame-right',
      true,
      true
    );
    return slidingDoorsInFrameSize && (alignedFrames.left || alignedFrames.right);
  });

  const slidingDoorsNotPossible =
    framesInScene?.length > 0 && framesThatCanHaveSlidingDoors?.length === 0;

  const determinePlacementAttemptErrorMessage = () => {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (
      !hidePlatsaSlidingDoorsNotPossibleErrorMessage(coreApi, rootState.products.inMarket)
    ) {
      return ErrorMessages.PlatsaSlidingDoorsNotPossible;
    } else if (!hidePlatsaAddingFrontToOpenFrameErrorMessage(coreApi)) {
      return ErrorMessages.PlatsaAddingDoorsToOpenFrames;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  if (slidingDoorsNotPossible) {
    // Trigger Add to get a placementAttempt and display feedback to the user
    coreApi.products.addToTarget('', framesInScene[0]);
  }

  framesThatCanHaveSlidingDoors.forEach(frame => {
    const existingFronts = HierarchyUtils.children(frame).filter(child =>
      coreApi.entities.isOneOfProductTypes(child, [
        ProductType.PLATSA_SC_HINGE_DOOR_ASM,
        ProductType.PLATSA_HINGE_DOOR_ASM,
        ProductType.PLATSA_DRAWER_ASM,
        ProductType.PLATSA_SLIDING_DOOR_ASM
      ])
    );
    coreApi.entities.deleteMultiple(existingFronts);
    const placementResult = coreApi.products.addToTarget(props.coreProductIds[0], frame);
    if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
      coreApi.entities.disposeCollidingEntities(placementResult.errors);
    }
  });
};

export default autoFillSlidingDoors;
